import { useState } from 'react';
import { benefitsApi } from '../../../api/benefits.js';

const cents = (v) => (v == null ? '—' : `IDR ${Number(v).toLocaleString('en-US')}`);

export default function DeductionPreview() {
  const [employeeId, setEmployeeId] = useState('');
  const [payDate, setPayDate] = useState('');
  const [feed, setFeed] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function load() {
    if (!employeeId || !payDate) return;
    setLoading(true);
    setError(null);
    try {
      const data = await benefitsApi.getDeductions({ employee_id: employeeId, pay_date: payDate });
      setFeed(data);
    } catch (e) {
      setError(e.response?.data?.message || 'Failed to load deductions');
    } finally {
      setLoading(false);
    }
  }

  return (
    <section data-testid="benefits-deductions-page" data-loading={loading ? 'true' : 'false'}>
      <header className="page-header">
        <h1>Deduction Feed Preview</h1>
        <p className="muted">Per-pay-period benefit deductions (Payroll feed)</p>
      </header>

      {error && <div className="alert error" data-testid="benefits-deductions-error">{error}</div>}

      <div className="card form-card">
        <label>Employee ID
          <input
            value={employeeId}
            onChange={(e) => setEmployeeId(e.target.value)}
            data-testid="benefits-ded-empid-input"
            placeholder="uuid"
          />
        </label>
        <label>Pay Date
          <input
            type="date"
            value={payDate}
            onChange={(e) => setPayDate(e.target.value)}
            data-testid="benefits-ded-date-input"
          />
        </label>
        <button className="btn primary" onClick={load} disabled={!employeeId || !payDate || loading} data-testid="benefits-ded-load">
          Preview Deductions
        </button>
      </div>

      {feed && (
        <div className="card" data-testid="benefits-deduction-feed">
          <div className="page-header">
            <div>
              <strong>Pay date: {feed.pay_date}</strong>
              <span className="muted"> · Period: {feed.period_start} → {feed.period_end}</span>
            </div>
            <div><strong>Total: {cents(feed.total_deduction_cents)}</strong></div>
          </div>

          <table className="data-table">
            <thead>
              <tr>
                <th>Plan</th>
                <th>Coverage</th>
                <th>Full Cost</th>
                <th>Prorated Cost</th>
                <th>Days Active</th>
                <th>Prorated?</th>
              </tr>
            </thead>
            <tbody>
              {(feed.deductions || []).map((d) => (
                <tr key={d.election_id} data-testid="benefits-deduction-row">
                  <td>{d.plan_name || d.plan_id}</td>
                  <td>{d.coverage_level}</td>
                  <td>{cents(d.per_pay_cost_cents)}</td>
                  <td><strong>{cents(d.prorated_cost_cents)}</strong></td>
                  <td>{d.days_active}/{d.days_in_period}</td>
                  <td>
                    {d.is_prorated
                      ? <span className="chip status-pending">Yes</span>
                      : <span className="chip status-active">Full</span>}
                  </td>
                </tr>
              ))}
              {feed.deductions?.length === 0 && (
                <tr><td colSpan={6} className="muted">No active elections for this period.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
